import axios from "axios";


export default () => {
  let token = null;
  const str = sessionStorage.getItem('profile');
  if (str) {
    token = JSON.parse(str).token;
  }
  return axios.create({
    baseURL: "https://admin.psggo.com/api",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Authorization": `SHA256 ${token}`
    }
  });
}
